import BaseService from '../../BaseService.js'

export default class OrtService extends BaseService {

  constructor() {
    super('ort')
  }

  async readPlzOrOrt(name, value) {
    this.abort()
    await this.retrieveBackendUrl()
    const queryParams = new URLSearchParams()
    queryParams.set(name, value)
    return this.checkError(
      fetch(`${this.backendUrl}?${queryParams.toString()}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader(),
        signal: this.controller.signal
      })
    )
  }

  abort() {
    if (this.controller) {
      this.controller.abort()
    }
    this.controller = new AbortController()
  }
}
